import { Robot, CheckCircle } from '@phosphor-icons/react';
import { formatAmount } from './taskHelpers';

export const TaskSidebar = ({
  subscriptionsByCurrency,
  amountsByCurrency,
  activePendingCount,
  forecastTasks,
  forecastByCurrency,
}) => {
  return (
    <div className="space-y-6">
      {/* AI Strategy */}
      <div className="stat-card">
        <div className="flex items-center gap-2 mb-4">
          <Robot size={20} weight="duotone" className="text-[#005bc1]" />
          <h3 className="title-md text-base">AI Strategy</h3>
        </div>
        <p className="body-lg text-sm mb-4">
          Detected a trend in your subscription spending. Eliminating unused services could save you{' '}
          {Object.keys(subscriptionsByCurrency).length > 0
            ? Object.entries(subscriptionsByCurrency).map(([cur, total], i) => (
                <span key={cur}>
                  {i > 0 && ' + '}
                  <span className="font-bold text-[#005bc1]">{formatAmount(total * 0.3, cur)}/month</span>
                </span>
              ))
            : <span className="font-bold text-[#005bc1]">--</span>
          }.
        </p>
        <div className="space-y-2">
          <div className="flex items-center gap-2 p-3 bg-[#d6e3ff] rounded-xl text-xs">
            <div className="w-2 h-2 rounded-full bg-[#005bc1]"></div>
            <span className="text-[#001b3d]">Consolidating payment windows...</span>
          </div>
          <div className="flex items-center gap-2 p-3 bg-[#a3f5b8] rounded-xl text-xs">
            <CheckCircle size={14} className="text-[#0f6b3a]" weight="fill" />
            <span className="text-[#0f6b3a]">Synced with Calendar</span>
          </div>
        </div>
      </div>

      {/* Due This Month */}
      <div className="stat-card-dark">
        <p className="label-md text-[#acb3b8] mb-3">Due This Month</p>
        <div className="space-y-2">
          {Object.entries(amountsByCurrency)
            .sort((a, b) => b[1] - a[1])
            .map(([cur, total]) => (
              <div key={cur} className="flex items-baseline justify-between">
                <span className="text-2xl font-bold text-white">
                  {formatAmount(total, cur)}
                </span>
                <span className="text-xs text-[#acb3b8] uppercase">{cur}</span>
              </div>
            ))}
          {Object.keys(amountsByCurrency).length === 0 && (
            <p className="text-2xl font-bold text-white">All clear!</p>
          )}
        </div>
        <p className="text-xs text-[#acb3b8] mt-3">
          {activePendingCount} active task{activePendingCount !== 1 ? 's' : ''}
        </p>
      </div>

      {/* Upcoming Forecast */}
      {forecastTasks.length > 0 && (
        <div className="stat-card border border-[#bae6fd]" style={{background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)'}}>
          <p className="label-md text-[#0369a1] mb-3">Upcoming Forecast</p>
          <div className="space-y-2">
            {Object.entries(forecastByCurrency)
              .sort((a, b) => b[1] - a[1])
              .map(([cur, total]) => (
                <div key={cur} className="flex items-baseline justify-between">
                  <span className="text-xl font-bold text-[#0c4a6e]">
                    {formatAmount(total, cur)}
                  </span>
                  <span className="text-xs text-[#0369a1] uppercase">{cur}</span>
                </div>
              ))}
          </div>
          <p className="text-xs text-[#0369a1] mt-3">
            {forecastTasks.length} projected from recurring tasks
          </p>
        </div>
      )}

      {/* Quick Action */}
      <div className="stat-card">
        <p className="title-md text-base mb-2">Quick Action</p>
        <p className="body-lg text-sm mb-4">Need me to call the dentist and reschedule?</p>
        <button className="btn-secondary w-full text-sm">
          Reschedule Appointment
        </button>
      </div>
    </div>
  );
};
